<script>
    import {t} from '$utils/lang.js';
    import {expressCheckoutOptions, paymentStore, fetchShippingAndPayment, handleCreateOrder, handleApproveOrder} from '$lib/paymentStore.svelte.js';
    import Title from "$component/Title.svelte";
    import {onMount} from 'svelte';

    const Paypal = () => import("./Payments/Paypal.svelte");
    const AmazonPayExpress = () => import("./Payments/AmazonPayExpress.svelte");
    const StripeExpress = () => import("./Payments/StripeExpress.svelte");

    onMount(() => {
        if (paymentStore.paymentMethods.length === 0 && !paymentStore.loading) {
            fetchShippingAndPayment();
        }
    });
</script>


<Title title={t("Express Checkout")} titleClass="leading-6.5 font-light text-center" class="pb-3 justify-center"/>
<div class="flex flex-col gap-1.5 text-sm">
    {#each expressCheckoutOptions() as option}
        {#if option.id === 'paypal-express'}
            {#await Paypal()}
                <div class="spinner">{t("Wird geladen...")}</div>
            {:then {default: PaypalComponent}}
                <div class="flex flex-col gap-1">
                    <PaypalComponent data={option.data} createOrder={(data, actions) => handleCreateOrder(option.paymentId, data, actions)}
                                     approveOrder={(data, actions) => handleApproveOrder(option.paymentId, data, actions)}/>
                </div>
            {/await}
        {:else if option.id === 'amazon-pay-express'}
            {#await AmazonPayExpress()}
                <div class="h-[42px] bg-gray-100 animate-pulse rounded"></div>
            {:then {default: AmazonPayExpressComponent}}
                <AmazonPayExpressComponent paymentId={option.paymentId} metadata={option.metadata}/>
            {/await}
        {:else if option.id === 'stripe-express'}
            {#await StripeExpress()}
                <div class="h-[42px] bg-gray-100 animate-pulse rounded"></div>
            {:then {default: StripeExpressComponent}}
                <StripeExpressComponent paymentId={option.paymentId} metadata={option.metadata}/>
            {/await}
        {/if}
    {/each}
</div>
